// Explicit opt-in. A stale/unverified read model always retains journal loading.
(() => {
  const canDefer = (metadata: any, state: any) => {
    const model = metadata?.readModels?.ledgerBalances;
    return metadata?.readModels?.journalLoading === 'on-demand' && model?.status === 'ready'
      && model.version === 1 && Number.isInteger(Number(model.verifiedThroughSeq))
      && Number(model.verifiedThroughSeq) === Number(state?.accountingRecordedSeqCounter || 0);
  };
  const request = () => {
    if (!runtime.journalDeferred || runtime.journalDemandPending) return;
    runtime.journalDemandPending = true;
    const businessId = runtime.activeBusinessId, loader = runtime.requestAccountingJournal;
    // Model getters can run during render. Begin I/O after the current render.
    Promise.resolve().then(() => { runtime.journalDemandPending = false; if (runtime.activeBusinessId === businessId && runtime.requestAccountingJournal === loader) loader?.(); });
  };
  const route = (name: string) => {
    runtime.journalRoute = name;
    // Conservative allowlist. Every unconverted consumer gets the complete journal.
    if (!['hjem', 'rapporter', 'mva', 'kjopsoversikt', 'fakturaliste'].includes(name)) request();
  };
  const routeNeedsJournal = () => !['hjem', 'rapporter', 'mva', 'kjopsoversikt', 'fakturaliste'].includes(runtime.journalRoute || 'hjem');
  const attach = ({ loader, coverage, metadata, state, year, ready = () => true }: any) => {
    let requested = false;
    runtime.requestAccountingJournal = () => { requested = true; runtime.journalDeferred = false; if (ready()) return loader.load(year()); };
    return (selectedYear: number) => {
      if (!ready()) return;
      runtime.journalDeferred = !requested && canDefer(metadata(), state()) && !routeNeedsJournal();
      if (!runtime.journalDeferred) return loader.load(selectedYear);
      return coverage.load(selectedYear);
    };
  };
  const readModelVerified = (state: any, year: number, options: any = {}) => {
    if (!state?.accountingJournalDeferred && !state?.accountingReadModelCoverage) return true;
    const payload = state.accountingReadModelCoverage;
    const coverage = payload?.accountingBasisCoverage;
    const period = options.fiscalBounds || { from: `${year}-01-01`, to: `${year}-12-31` };
    return payload?.finalized === true && Number(payload.year) === Number(year) && payload.businessId === runtime.activeBusinessId && coverage?.authority === 'server'
      && ['COMPLETE', 'EMPTY'].includes(coverage.status)
      && coverage.period?.from === period.from && coverage.period?.to === period.to
      && Number(coverage.basis_recorded_seq) === Number(state.accountingRecordedSeqCounter || 0)
      && ['complete_journal_through_watermark', 'paginated_journal_through_watermark'].includes(coverage.read_scope?.mode);
  };
  (window as any).PlummeJournalDemand = { canDefer, request, route, routeNeedsJournal, attach, readModelVerified };
})();
